// Utility function to format prices in INR
export const formatPrice = (priceInUSD) => {
  // Convert USD to INR (approximate rate: 1 USD = 83 INR)
  const priceInINR = priceInUSD * 83;
  
  // Format with Indian number system (lakhs, crores)
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(priceInINR);
};

// Function to convert USD to INR without formatting
export const convertToINR = (priceInUSD) => {
  return Math.round(priceInUSD * 83);
};

// Function to format INR with proper Indian formatting
export const formatINR = (priceInINR) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(priceInINR);
};
